export const initialClientForCompanyFilter = {
  companyName: null,
  legalFormId: null,
  legalFormCode: null,
  taxId: null,
  street1: null,
  street2: null,
  city: null,
  zip: null,
  state: null,
  cityDistrictCounty: null,
  registrationNumber: null,
  pin: null,
  firstName: null,
  lastName: null,
  birthDate: null,
  email: null,
  areaOfActivityId: null,
  countryId: null,
  countyId: null,
  cityId: null,
  street: null,
  streetNumber: null,
  neighborhood: null,
  registrationDate: null,
};

export const initialPerson = {
  genderId: null,
  firstName: null,
  lastName: null,
  birthDate: null,
  identityCardNo: null,
  street: null,
  streetNumber: null,
  countryId: null,
  countyId: null,
  cityId: null,
  zip: null,
  email: null,
  phone: null,
  nationality: null,
  areaOfActivityId: null,
  neighborhood: null,
  registrationDate: null,
  addOfficialAddress: false,
};

export const initialAddress = {
  street: null,
  streetNumber: null,
  countryId: null,
  countyId: null,
  cityId: null,
  zip: null,
};
